import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "heading", "children", "cta", "layout", "textColor"];
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Card, Flex, Button, OutlineButton, NakedButton, Image } from "./..";
import { rem } from 'polished';
import { CustomNakedButton, ContentWithLink, HeadingWithLink, BannerContainer } from "./primitives";
var CtaMap = {
  primary: Button,
  outline: OutlineButton,
  text: CustomNakedButton,
  naked: NakedButton
};

var DetailedBanner = function DetailedBanner(_ref) {
  var icon = _ref.icon,
      heading = _ref.heading,
      children = _ref.children,
      cta = _ref.cta,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'column' : _ref$layout,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? {
    heading: 'greys.charcoal',
    content: 'greys.steel'
  } : _ref$textColor,
      rest = _objectWithoutProperties(_ref, _excluded);

  var src = icon.src,
      alt = icon.alt;
  var CtaComponent = CtaMap[cta === null || cta === void 0 ? void 0 : cta.type] || null;
  var isHorizontal = layout === 'row';
  return /*#__PURE__*/React.createElement(Card, _extends({}, rest, {
    display: "flex",
    flexDirection: ['column', 'row'],
    p: [5, 6, rem('34px')]
  }), /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt,
    size: rem('48px'),
    mr: 2,
    mb: [4, 0]
  }), /*#__PURE__*/React.createElement(BannerContainer, {
    hasContent: !!children,
    layout: layout,
    isHorizontal: isHorizontal,
    hasCta: !!cta
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    maxWidth: rem('980px'),
    width: ['100%', '100%', isHorizontal ? '70%' : '100%']
  }, /*#__PURE__*/React.createElement(HeadingWithLink, {
    fontSize: rem('18px'),
    fontWeight: "bold",
    color: textColor.heading
  }, heading), children && /*#__PURE__*/React.createElement(ContentWithLink, {
    pt: 2,
    m: 0,
    color: textColor.content
  }, children)), cta && CtaComponent && /*#__PURE__*/React.createElement(Flex, {
    mt: [3, 3, isHorizontal ? 0 : 3],
    minWidth: ['100%', rem('290px'), isHorizontal ? rem('180px') : rem('290px')],
    justifyContent: ['flex-start', 'flex-start', isHorizontal ? 'flex-end' : 'flex-start']
  }, /*#__PURE__*/React.createElement(CtaComponent, _extends({
    width: "100%",
    onClick: cta.onClick,
    variant: "primary"
  }, cta.buttonStyles), cta.label, cta.iconName && /*#__PURE__*/React.createElement(Icon, {
    name: cta.iconName,
    ml: 2,
    mb: 1
  })))));
};

DetailedBanner.propTypes = {
  icon: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  }).isRequired,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
  cta: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    type: PropTypes.oneOf(['primary', 'outline', 'text', 'naked']),
    iconName: PropTypes.string,
    onClick: PropTypes.func,
    buttonStyles: PropTypes.object
  }),
  layout: PropTypes.oneOf(['row', 'column']),
  textColor: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string
  })
};
export default DetailedBanner;